
const STRIPE_PUBLIC_KEY = 'pk_live_51R1RAXIpcmZ0ESIUvNUTohlkVktFwPpnTToE6mOh8rQ1LejoSPPdnKZ9L7z2pLq4nD8vBBNkQMBnmD1YX3EQ6ULO00YjCDy573';

export default STRIPE_PUBLIC_KEY;